<fury-loading-indicator></fury-loading-indicator>
<router-outlet></router-outlet>
